module.exports = __webpack_public_path__ + "img/download (1).c4d9993a.svg";